var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardFileUploadAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#E4E7EC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1614_14005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 35C36.3597 35 37.689 34.5968 38.8195 33.8414C39.9501 33.0859 40.8313 32.0122 41.3517 30.756C41.872 29.4997 42.0082 28.1174 41.7429 26.7838C41.4776 25.4501 40.8228 24.2251 39.8614 23.2636C38.8999 22.3022 37.6749 21.6474 36.3412 21.3821C35.0076 21.1168 33.6253 21.253 32.3691 21.7733C31.1128 22.2937 30.0391 23.1749 29.2836 24.3055C28.5282 25.436 28.125 26.7653 28.125 28.125C28.1268 29.9478 28.8517 31.6954 30.1407 32.9844C31.4296 34.2733 33.1772 34.9982 35 35ZM35 23.5417C35.9065 23.5417 36.7926 23.8105 37.5464 24.3141C38.3001 24.8177 38.8875 25.5335 39.2344 26.371C39.5814 27.2085 39.6721 28.1301 39.4953 29.0192C39.3184 29.9082 38.8819 30.7249 38.2409 31.3659C37.5999 32.0069 36.7832 32.4434 35.8942 32.6203C35.0051 32.7971 34.0835 32.7064 33.246 32.3595C32.4085 32.0125 31.6927 31.4251 31.1891 30.6714C30.6855 29.9176 30.4167 29.0315 30.4167 28.125C30.4167 26.9094 30.8996 25.7436 31.7591 24.8841C32.6186 24.0246 33.7844 23.5417 35 23.5417Z",
    fill: "#98A2B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 37.293C32.2659 37.296 29.6446 38.3835 27.7113 40.3168C25.778 42.2501 24.6905 44.8714 24.6875 47.6055C24.6875 47.9094 24.8082 48.2008 25.0231 48.4157C25.238 48.6306 25.5294 48.7513 25.8333 48.7513C26.1372 48.7513 26.4287 48.6306 26.6436 48.4157C26.8584 48.2008 26.9792 47.9094 26.9792 47.6055C26.9792 45.4782 27.8242 43.4381 29.3284 41.9339C30.8326 40.4297 32.8727 39.5846 35 39.5846C37.1272 39.5846 39.1674 40.4297 40.6716 41.9339C42.1758 43.4381 43.0208 45.4782 43.0208 47.6055C43.0208 47.9094 43.1415 48.2008 43.3564 48.4157C43.5713 48.6306 43.8628 48.7513 44.1667 48.7513C44.4706 48.7513 44.762 48.6306 44.9769 48.4157C45.1918 48.2008 45.3125 47.9094 45.3125 47.6055C45.3095 44.8714 44.222 42.2501 42.2887 40.3168C40.3554 38.3835 37.7341 37.296 35 37.293Z",
    fill: "#98A2B3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1614_14005"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.5,
    height: 27.5,
    fill: "white",
    transform: "translate(21.25 21.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardFileUploadAvatar);
export default __webpack_public_path__ + "static/media/dashboard-file-upload-avatar.b0456293df4d2adb45acc23347534222.svg";
export { ForwardRef as ReactComponent };